import { FormControl } from '@angular/forms'
import { ToastService } from '@common/services'
import { Component, Input, ViewChild, OnInit } from '@angular/core'
import { NoticeSession } from '@models/planning/notice-session.model'
import { UploadS3Service } from '@services/upload-s3.service'
import { UploadStatus } from '@models/attachment/upload-attachment.model'
import { AttachmentServiceType } from '@models/attachment/attachment.model'
import { AttachmentService } from '@services/attachment.service'
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap'
import { Observable, EMPTY, map, firstValueFrom, finalize } from 'rxjs'
import { NoticeSessionService } from '@services/notice-session.service'
import { DemandIntentDocument } from '@models/demand/demand-intent-document.model'
import {
	NoticeSessionMessage,
	NoticeSessionMessageStatus,
	NoticeSessionMessageSenderType,
	MessageAttachmentDownloadType
} from '@models/planning/notice-session-message.model'

@Component({
	selector: 'app-session-message',
	templateUrl: './session-message.component.html',
	styleUrl: './session-message.component.scss',
	standalone: false
})
export class SessionMessageComponent implements OnInit {
	@ViewChild('modalAttachmentView') modalAttachmentView: NgbModalRef
	@ViewChild('modalRequestMessage') modalRequestMessage: NgbModalRef

	@Input() demand!: DemandIntentDocument

	submitted: boolean
	attachmentUrl: any
	attachmentTitle: string
	attachmentLoading: boolean
	sessionMessage!: NoticeSessionMessage
	sessionMessageControl = new FormControl<string>(null)
	sessionAttachmentControl = new FormControl<File>(null)
	sessionMessage$: Observable<Array<NoticeSessionMessage>> = EMPTY

	constructor(
		private modal: NgbModal,
		private toast: ToastService,
		private uploadS3Service: UploadS3Service,
		private attachmentService: AttachmentService,
		private noticeSessionService: NoticeSessionService
	) {}

	ngOnInit() {
		this.fetchSessionMessages()
	}

	saveMessage() {
		const file = this.sessionAttachmentControl.value
		const message = this.sessionMessageControl.value

		if (!message && !file) {
			this.toast.warn('Informe a mensagem ou um arquivo para continuar!')
			return
		}

		const entity = new NoticeSessionMessage({
			message,
			type: this.sessionMessage.type,
			status: NoticeSessionMessageStatus.SENT,
			senderType: NoticeSessionMessageSenderType.AGENT,
			hasAttachment: file !== null && file !== undefined,
			comment: new NoticeSessionMessage({ id: this.sessionMessage.id }),
			noticeSession: new NoticeSession({ id: this.demand.noticeSession.id })
		})

		this.submitted = true
		this.noticeSessionService.sendMessage(entity).subscribe({
			next: async response => {
				if (file) {
					const responseAttachment = await this.uploadS3Service.uploadAttachment(
						response.id,
						this.sessionAttachmentControl.value,
						AttachmentServiceType.MANAGEMENT_PROCESS
					)

					if (responseAttachment.status === UploadStatus.ERROR) {
						this.toast.error('Tívemos um problema ao tentar enviar o arquivo.')
						await firstValueFrom(this.noticeSessionService.deleteMessage(response.id).pipe(finalize(() => (this.submitted = false))))
						return
					}
				}

				this.submitted = false
				this.modal.dismissAll()
				this.fetchSessionMessages()
				this.toast.success('Enviado com sucesso')
			},
			error: () => (this.submitted = false)
		})
	}

	modalSessionMessage(item: NoticeSessionMessage) {
		this.sessionMessage = item

		this.sessionMessageControl.setValue(null)
		this.sessionAttachmentControl.setValue(null)

		const modal = this.modal.open(this.modalRequestMessage, { backdrop: 'static', size: 'lg', keyboard: false })

		modal.dismissed.subscribe(() => {
			this.submitted = false
			this.sessionMessageControl.setValue(null)
			this.sessionAttachmentControl.setValue(null)
		})

		modal.closed.subscribe(() => {
			this.submitted = false
			this.sessionMessageControl.setValue(null)
			this.sessionAttachmentControl.setValue(null)
		})
	}

	onSessionAttachmentSelected(event: Event) {
		const input = event.target as HTMLInputElement

		if (input.files && input.files.length > 0) {
			const file = input.files[0]

			if (file.size > 40 * 1024 * 1024) {
				this.toast.warn('O tamanho do arquivo não pode maior que 40MB')
				return
			}

			if (file.type !== 'application/pdf') {
				this.sessionAttachmentControl.setValue(null)
				this.toast.warn('Formato invalido, informe um arquivo em PDF.')
				return
			}

			this.sessionAttachmentControl.setValue(file)
		}
	}

	messageAttachmentDownload(item: MessageAttachmentDownloadType, resourceId: string) {
		if (item.hasAttachment) {
			item.submitted = true
			this.attachmentService
				.downloadHandleBlob(resourceId)
				.pipe(finalize(() => (item.submitted = false)))
				.subscribe(response => {
					this.attachmentUrl = response
					this.modal.open(this.modalAttachmentView, { fullscreen: true })
				})
		}
	}

	protected fetchSessionMessages() {
		this.sessionMessage$ = this.noticeSessionService.messages(this.demand.noticeSession.id, this.demand.noticeSession.tenantId).pipe(
			map(response =>
				response.map(it => {
					it.myRequest = false
					return it
				})
			)
		)
	}
}
